import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AbstractContentComponent } from '../abstract-content.component';
import { Context } from '@service/context.service';
import { Column } from '@shared/table/column';
import { ChopKatalog } from '@entity/chop';
import { ChopService } from '@service/chop.service';
import { ChopKatalogDialogComponent } from './chop-katalog-detail/chop-katalog-dialog/chop-katalog-dialog.component';
import { ActionButtonDirective } from '@shared/table/action-button.directive';
import { ToolbarButtonDirective } from '@shared/table/toolbar-button.directive';
import { TableComponent } from '@shared/table/table.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-chop-kataloge',
  templateUrl: './chop-kataloge.component.html',
  styleUrls: ['./chop-kataloge.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableComponent, ToolbarButtonDirective, ActionButtonDirective],
})
export class ChopKatalogeComponent extends AbstractContentComponent implements OnInit {
  private chopService = inject(ChopService);

  kataloge: ChopKatalog[] = this.activatedRoute.snapshot.data.kataloge;
  columns: Column[] = [];

  constructor() {
    super(Context.Global, 'MENU.CHOP');
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setColumns();
  }

  protected onLanguageChange(): void {
    this.setColumns();
    this.markForCheck();
  }

  reload(): void {
    this.chopService.getKataloge().subscribe((kataloge) => {
      this.kataloge = kataloge;
      this.markForCheck();
    });
  }

  showCreateDialog(): void {
    this.openDialog()?.onClose.subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }

  showEditDialog(katalog: ChopKatalog): void {
    this.openDialog(katalog)?.onClose.subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }

  openDetail(katalog: ChopKatalog): void {
    this.navigate(['kataloge', katalog.id]);
  }

  delete(katalog: ChopKatalog): void {
    this.confirm({
      header: this.translate('CHOP.DELETE_KATALOG_HEADER'),
      message: this.translate('CHOP.DELETE_KATALOG_MESSAGE', {
        bezeichnung: this.getLocalizedText(katalog.bezeichnung),
      }),
      accept: () => {
        this.chopService.deleteKatalog(katalog.id).subscribe({
          next: () => {
            this.showSuccessMessage();
            this.reload();
          },
          error: (err) => this.showErrorMessage(undefined, err?.error?.message),
        });
      },
    });
  }

  private openDialog(katalog?: ChopKatalog): DynamicDialogRef | null {
    return this.dialogService.open(ChopKatalogDialogComponent, {
      modal: true,
      closable: true,
      focusOnShow: false,
      width: '500px',
      header: this.translate(katalog ? 'CHOP.EDIT_KATALOG' : 'CHOP.CREATE_KATALOG'),
      data: { katalog },
    });
  }

  private setColumns(): void {
    this.columns = [
      { field: 'jahr', headerKey: 'CHOP.JAHR', width: '120px', filterType: 'integer' },
      { field: 'bezeichnung.De', headerKey: 'GLOBAL.NAME_De', minWidth: '200px' },
      { field: 'bezeichnung.Fr', headerKey: 'GLOBAL.NAME_Fr', minWidth: '200px' },
      { field: 'bezeichnung.It', headerKey: 'GLOBAL.NAME_It', minWidth: '200px' },
    ];
  }
}
